<!--page-wrapper Start-->
<div class="page-wrapper">
    <app-alerts></app-alerts>
    <router-outlet></router-outlet>
</div>
<!--page-wrapper Ends-->